
  (function () {
    if (window.__hovProductCardMotion) return;
    window.__hovProductCardMotion = true;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var seen = new WeakSet();

    function armImage(img) {
      if (!img || img.dataset.hovArmed) return;
      img.dataset.hovArmed = '1';
      // First-screen images should paint immediately rather than wait for a fade.
      if (reduce || img.loading === 'eager' || (img.complete && img.naturalWidth > 0)) return;
      img.classList.add('is-pending');
      function done() {
        img.classList.remove('is-pending');
      }
      if (img.complete) {
        done();
        return;
      }
      img.addEventListener('load', done, { once: true });
      img.addEventListener('error', done, { once: true });
    }

    function armCard(card, arriving) {
      if (!card || seen.has(card)) return;
      seen.add(card);
      card.querySelectorAll('.product-card__image--primary').forEach(armImage);
      if (!arriving || reduce) return;
      card.classList.add('is-arriving');
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          card.classList.remove('is-arriving');
          card.classList.add('is-arrived');
        });
      });
    }

    function scan(root, arriving) {
      var scope = root && root.querySelectorAll ? root : document;
      if (scope.matches && scope.matches('.product-card')) armCard(scope, arriving);
      scope.querySelectorAll('.product-card').forEach(function (card) {
        armCard(card, arriving);
      });
    }

    function start() {
      scan(document, false);
      if (!('MutationObserver' in window)) return;
      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(function (node) {
            if (!node || node.nodeType !== 1) return;
            scan(node, true);
          });
        });
      });
      var main = document.getElementById('MainContent') || document.body;
      observer.observe(main, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
  })();
